module.exports = __webpack_public_path__ + "static/Bundesstiftung-Logo@2x.19e5c3bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/BALogo/Bundesstiftung-Logo@2x.png
// module id = 413
// module chunks = 35783957827783